module.exports = __webpack_public_path__ + "img/gg_close.30d671fb.svg";